import { render, staticRenderFns } from "./RelevantNotice.vue?vue&type=template&id=66da6258&scoped=true&"
import script from "./RelevantNotice.vue?vue&type=script&lang=js&"
export * from "./RelevantNotice.vue?vue&type=script&lang=js&"
import style0 from "./RelevantNotice.vue?vue&type=style&index=0&id=66da6258&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da6258",
  null
  
)

export default component.exports